<!--http://localhost:4200/en/ski-rental/countries-->
<div class="main-container">
  <div class="main-container-bg"></div>
  <div class="container">
    @if (error) {
      <button class="btn btn-primary" (click)="tryReload()">
        {{ 'ALPINSKIHIRE.zoomIn.retry' | alpitranslate }}
      </button>
    }
    @if (loading) {
      <div class="container__content main container">
        <div class="col-lg-12 product clearfix">
          <div class="loader-inner">
            <div class="text-center">
              <div class="spinner-border" role="status"></div>
            </div>
            <div class="text-center">Loading</div>
          </div>
        </div>
      </div>
    }
    @if (countries && !loading) {
      <div class="row">
        <div class="col-12 col-lg-4">
          <div class="d-md-block">
            @if (!isMobile) {
              <div class="text-header">{{ 'CORE.skiHire' | alpitranslate }}</div>
            }
            <app-shop-search
              [isIncludedOnStart]="true"
              [implementationPage]="'zoomInPage'"
              [toggle]="isMobile ? true : false"
              (sentForm)="goTo($event)">
            </app-shop-search>
          </div>
        </div>
        <div class="col-12 col-lg-8">
          <!-- Countries -->
          <div class="card">
            <div class="card-header c-pointer" (click)="toggle('country')">
              <div class="card-title text-primary">
                <span>{{ 'ALPINSKIHIRE.zoomIn.country' | alpitranslate }}</span>
                @if (!showCountry && country) {
                  <span class="card-subtitle">{{ countryName }}</span>
                }
              </div>
              <app-icon name="chevronDown" class="text-primary ml-auto" [class.open]="showCountry" />
            </div>
            @if (showCountry) {
              <div class="card-body collapsible" @collapsible>
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="place-wrapper">
                      @for (_country of countries; track _country; let i = $index) {
                        <div>
                          <a [routerLink]="['/SKIHIREENTRY/' + _country.slugs[lang]] | localize">
                            @if (i < getHalfPoint('country')) {
                              <div class="place">
                                <span>{{ _country.names[lang] }}</span>
                                <img
                                  class="flag-img"
                                  src="{{
                                    'images/flags/country_' + getCountryCode(_country.slugs['en']) + '.svg'
                                      | platformasset: true
                                  }}" />
                              </div>
                            }
                          </a>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="place-wrapper">
                      @for (_country of countries; track _country; let i = $index) {
                        <div>
                          <a [routerLink]="['/SKIHIREENTRY/' + _country.slugs[lang]] | localize">
                            @if (i >= getHalfPoint('country')) {
                              <div class="place">
                                <span>{{ _country.names[lang] }}</span>
                                <img
                                  class="flag-img"
                                  src="{{
                                    'images/flags/country_' + getCountryCode(_country.slugs['en']) + '.svg'
                                      | platformasset: true
                                  }}" />
                              </div>
                            }
                          </a>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <!-- Regions -->
          @if (country) {
            <div class="card">
              <div class="card-header c-pointer" (click)="toggle('province')">
                <div class="card-title text-primary">
                  <span>{{ 'ALPINSKIHIRE.zoomIn.province' | alpitranslate }}</span>
                  @if (!showProvince && province) {
                    <span class="card-subtitle">{{ provinceName }}</span>
                  }
                </div>
                <app-icon name="chevronDown" class="text-primary ml-auto" [class.open]="showProvince" />
              </div>
              @if (showProvince) {
                <div class="card-body collapsible" @collapsible>
                  <div class="row">
                    <div class="col-12 col-lg-6">
                      <div class="place-wrapper">
                        @for (_province of provinces; track _province; let i = $index) {
                          <div>
                            <a [routerLink]="['/SKIHIREENTRY/' + _province.slugs[lang]] | localize">
                              @if (i < getHalfPoint('province')) {
                                <div class="place">
                                  <span>{{ _province.names[lang] }}</span>
                                </div>
                              }
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="place-wrapper">
                        @for (_province of provinces; track _province; let i = $index) {
                          <div>
                            <a [routerLink]="['/SKIHIREENTRY/' + _province.slugs[lang]] | localize">
                              @if (i >= getHalfPoint('province')) {
                                <div class="place">
                                  <span>{{ _province.names[lang] }}</span>
                                </div>
                              }
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          <!-- Villages -->
          @if (country) {
            <div class="card">
              <div class="card-header c-pointer" (click)="toggle('town')">
                <div class="card-title text-primary">
                  <span>{{ 'ALPINSKIHIRE.zoomIn.town' | alpitranslate }}</span>
                </div>
                <app-icon name="chevronDown" class="text-primary ml-auto" [class.open]="showTowns" />
              </div>
              @if (showTowns) {
                <div class="card-body collapsible" @collapsible>
                  <div class="row">
                    <div class="col-12 col-lg-6">
                      <div class="place-wrapper">
                        @for (town of towns; track town; let i = $index) {
                          <div>
                            <a [routerLink]="['/SKIHIREENTRY/' + town.slugs[lang]] | localize">
                              @if (i < getHalfPoint('town')) {
                                <div class="place">
                                  <span>{{ town.name }}</span>
                                </div>
                              }
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="place-wrapper">
                        @for (town of towns; track town; let i = $index) {
                          <div>
                            <a [routerLink]="['/SKIHIREENTRY/' + town.slugs[lang]] | localize">
                              @if (i >= getHalfPoint('town')) {
                                <div class="place">
                                  <span>{{ town.name }}</span>
                                </div>
                              }
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
